import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ActivityInfoComponent } from './activity-info.component';

export const ngxActivityInfoModule = angular.module('ngxActivityInfoModule', [])
	.directive('ngxActivityInfo', downgradeComponent({ component: ActivityInfoComponent }))
	.name;
